import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'

export default function EditCalendar({ clinicianProfile, setCalendarLink, updateClinicianCalendar }) {
  return (
    <Col style={{ flex: 2.25 }}>
      <Row style={spaceOut}>
        <div
          style={{
            fontSize: 28,
            color: 'rgba(0, 127, 97, 1)',
            textTransform: 'capitalize',
            fontFamily: 'GT Super Display',
            fontWeight: '500',
            marginTop: 60,
          }}
        >
          Manage my consultation
        </div>
      </Row>
      <Row style={spaceOut}>
        <Form.Group className="mb-3 mt-3" controlId="calendarLink">
          <Form.Label>Please provide your personal TBD calender (cal.com)link. This link will be provided to patients for their telemedicine consultations.</Form.Label>
          <Form.Control
            type="text"
            defaultValue={clinicianProfile?.calendarLink || ''}
            placeholder="Enter Calender Link"
            onChange={e => setCalendarLink(e.target.value)}
          />
        </Form.Group>
        <Button
          variant="light"
          onClick={updateClinicianCalendar}
          style={{
            width: 180,
            height: 40,
            marginLeft: 20,
            borderRadius: 8,
            backgroundColor: 'rgba(0, 127, 97, 1)',
            fontSize: 20,
            fontWeight: '600',
            lineHeight: '100%',
            color: 'rgba(253, 250, 241, 1)',
            border: 'none',
            marginRight: 40,
            letterSpacing: 1.5,
          }}
        >
          + Add Link
        </Button>
      </Row>
    </Col>
  )
}

const spaceOut = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}
